import { useContext as M, useCallback as j, useState as z, useRef as R, useEffect as w } from "react";
import { I18nContext as O, ReportNamespaces as _ } from "./help-center-knowledge-anatomies40.js";
import { warnOnce as E, hasLoadedNamespace as v, loadLanguages as p, loadNamespaces as C, isString as S, isObject as L } from "./help-center-knowledge-anatomies41.js";
import { getI18n as $ } from "./help-center-knowledge-anatomies42.js";
import { getDefaults as G } from "./help-center-knowledge-anatomies43.js";
const J = (i, t) => {
  const o = R();
  return w(() => {
    o.current = i;
  }, [i, t]), o.current;
}, P = (i, t, o, l) => i.getFixedT(t, o, l), U = (i, t, o, l) => j(P(i, t, o, l), [i, t, o, l]), H = (i, t = {}) => {
  const {
    i18n: o
  } = t, {
    i18n: l,
    defaultNS: A
  } = M(O) || {}, e = o || l || $();
  if (e && !e.reportNamespaces && (e.reportNamespaces = new _()), !e) {
    E(e, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const s = (a, c) => S(c) ? c : L(c) && S(c.defaultValue) ? c.defaultValue : Array.isArray(a) ? a[a.length - 1] : a, r = [s, {}, !1];
    return r.t = s, r.i18n = {}, r.ready = !1, r;
  }
  e.options.react?.wait && E(e, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const d = {
    ...G(),
    ...e.options.react,
    ...t
  }, {
    useSuspense: I,
    keyPrefix: y
  } = d;
  let n = i || A || e.options?.defaultNS;
  n = S(n) ? [n] : n || ["translation"], e.reportNamespaces.addUsedNamespaces?.(n);
  const u = (e.isInitialized || e.initializedStoreOnce) && n.every((s) => v(s, e, d)), F = U(e, t.lng || null, d.nsMode === "fallback" ? n : n[0], y), b = () => F, T = () => P(e, t.lng || null, d.nsMode === "fallback" ? n : n[0], y), [h, m] = z(b);
  let N = n.join();
  t.lng && (N = `${t.lng}${N}`);
  const x = J(N), f = R(!0);
  w(() => {
    const {
      bindI18n: s,
      bindI18nStore: r
    } = d;
    f.current = !0, !u && !I && (t.lng ? p(e, t.lng, n, () => {
      f.current && m(T);
    }) : C(e, n, () => {
      f.current && m(T);
    })), u && x && x !== N && f.current && m(T);
    const a = () => {
      f.current && m(T);
    };
    return s && e?.on(s, a), r && e?.store.on(r, a), () => {
      f.current = !1, e && s && s?.split(" ").forEach((c) => e.off(c, a)), r && e && r.split(" ").forEach((c) => e.store.off(c, a));
    };
  }, [e, N]), w(() => {
    f.current && u && m(b);
  }, [e, y, u]);
  const g = [h, e, u];
  if (g.t = h, g.i18n = e, g.ready = u, u || !u && !I) return g;
  throw new Promise((s) => {
    t.lng ? p(e, t.lng, n, () => s()) : C(e, n, () => s());
  });
};
export {
  H as useTranslation
};
//# sourceMappingURL=help-center-knowledge-anatomies10.js.map
